module.exports = __webpack_public_path__ + "img/Monte_Kope_101.8e747a18.jpg";